import React from 'react';
import classNames from "classnames";
import { getOtherProperties } from "../common/Utils";
import { AvatarProps } from "./PropsType";

export default function Avatar(props: AvatarProps) {
  const {
    height,
    src: srcProps,
    alt,
    lazyLoad,
    className,
    children,
    shape,
    title,
    prefixCls = "bm-Avatar",
    width,
    ...other
  } = props;
  const styleClass = classNames(prefixCls, className, {
    [`${prefixCls}-circle`]: shape === "circle",
  });
  const otherProps = getOtherProperties(other, [""]);
//   const src = lazyLoad ? this.state.src! : srcProps;
  const styles = {
    width,
    height,
  };
  return (
    <div className={styleClass} {...otherProps}>
      {srcProps ? (
        <img style={styles} src={srcProps} alt={alt} title={title} />
      ) : (
        children
      )}
    </div>
  );
}
